import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from '@chakra-ui/react';
import {getOrderById} from 'api/requests';
import {useCustomerContext} from 'components/providers';
import {IModalProps, Modal} from 'components/shared';
import {useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import React, {FC, useRef} from 'react';
import GTMService from 'services/ga4';
import {modalCloseButtonStyles} from 'theme';
import logger from 'utils/logger';

interface Props extends IModalProps {
  isOpen: boolean;
  url: string;
  routerShouldReplace?: boolean;
  uuid: string;
}

export const MaibPaymentModal: FC<Props> = ({onClose, isOpen, url, routerShouldReplace, uuid}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const {replace} = useRouter();
  const {t} = useTranslation();
  // alert
  const {isOpen: alertIsOpen, onOpen: alertOnOpen, onClose: alertOnClose} = useDisclosure();
  const cancelRef = React.useRef<any>(null);
  const {customer} = useCustomerContext();

  if (!isOpen) return null;
  return (
    <>
      <Modal isOpen={isOpen} onClose={alertOnOpen}>
        <ModalContent maxW="900px" h="90%" mx={['15px', 0]} bg="#d3d7da !important">
          <ModalHeader display="flex" alignItems="center" justifyContent="space-between">
            <ModalCloseButton ref={cancelRef} onClick={alertOnOpen} position="static" sx={modalCloseButtonStyles} />
          </ModalHeader>
          <ModalBody h="700px" overflowY="scroll" margin={0} padding="5px">
            <iframe
              ref={iframeRef}
              onLoad={async () => {
                const iframe = iframeRef.current;
                if (!iframe) return;
                try {
                  const iframeDocument = iframe.contentDocument || iframe?.contentWindow?.document;
                  logger.logDebug(`Iframe Document URL: ${iframeDocument}, ${iframeDocument?.URL}`);

                  if (iframeDocument?.URL?.includes('checkout/successcard')) {
                    const order = await getOrderById(uuid);
                    GTMService.purchase(order, customer);
                    if (routerShouldReplace) return replace(iframeDocument.URL);
                    onClose();
                    window?.location?.replace(iframeDocument.URL);
                  }
                } catch (error) {
                  console.error('Unable to access iframe:', error);
                }
              }}
              src={url}
              style={{width: '100%', height: '95%', border: 'none'}}
              allow="payment"
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={alertOnClose}
        isOpen={alertIsOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader> </AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>{t('closeMaibModalDisclaimer')}</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={alertOnClose}>
              {t('no')}
            </Button>
            <Button
              colorScheme="red"
              ml={3}
              onClick={() => {
                alertOnClose();
                onClose();
              }}
            >
              {t('yes')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
